import React from 'react'
import Preloader from '../Preloader/Preloader';
import styles from './LoaderWithoutText.module.scss';

export const LoaderWithoutText = () => {
  return (
    <div className={styles.wrapper}>
      <Preloader />
    </div>
  )
}
